const { default: axiosIns } = require('@/libs/axios')

const PresetService = {
  // GET - PresetApiController
  async getPresets() {
    return axiosIns.get('admin/presets')
      .then(response => response.data)
  },
  // PUT - PresetApiController
  async updatePreset(model) {
    return axiosIns.put(`admin/presets/${model.id}`, model).then(response => response.data)
  },
  // POST - PresetApiController
  async createPreset(model) {
    return axiosIns.post('admin/presets', model).then(response => response.data)
  },
}

export default PresetService
